//apifetch
import axios from 'axios';

//translate
import i18n from '../../translate/i18n';

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const GetReviewsApi = async (id: number, params:any) => {
  try {
    const response = await axios.get(params !== null ? `${baseURL}/reviews/car/${id}?${params}` : `${baseURL}/reviews/car/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error(error.response?.data || error.message);
    throw error;
  }
};